var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29,
    height: 14,
    rx: 7,
    fill: "#DB2358",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.1845,10L8.9245,10L6.0715,5.689L6.0715,10L4.8115,10L4.8115,3.709L6.0715,3.709L8.9245,8.029L8.9245,3.709L10.1845,3.709L10.1845,10ZM12.6865,4.734999999999999L12.6865,6.31L14.8015,6.31L14.8015,7.309L12.6865,7.309L12.6865,8.974L15.0715,8.974L15.0715,10L11.4265,10L11.4265,3.709L15.0715,3.709L15.0715,4.734999999999999L12.6865,4.734999999999999ZM24.6115,3.718L22.8565,10L21.3715,10L20.1925,5.527L18.9595,10.009L17.4835,10.009L15.7915,3.718L17.1415,3.718L18.2485,8.596L19.5265,3.718L20.9305,3.718L22.1365,8.568999999999999L23.2525,3.718L24.6115,3.718Z",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.abd15e25210c8f1d39bced3c4115bfa6.svg";
export { ForwardRef as ReactComponent };